import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Search, PlusCircle, PenTool, CheckCircle, CreditCard, DollarSign, Wallet, Landmark, PiggyBank, Vote, Gift, FileText, Settings, Lock, UserMinus, Users, Calculator, Banknote, Layers, ShieldCheck, ChartBar, Phone, Building2, ArrowRightLeft } from 'lucide-react';
import MainLayout from './components/MainLayout';
import ModuleLayout from './components/ModuleLayout';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

// Components Imports
import Parametrizacion from './components/Parametrizacion';
import PersonasParametrizacion from './components/parametrizacion/PersonasParametrizacion';
import ProductosParametrizacion from './components/parametrizacion/ProductosParametrizacion';
import TesoreriaParametrizacion from './components/parametrizacion/TesoreriaParametrizacion';
import GlobalParametrizacion from './components/parametrizacion/GlobalParametrizacion';
import ArqueoCaja from './components/ArqueoCaja';
import Socios from './components/Socios';
import Finanzas from './components/Finanzas';
import Votaciones from './components/Votaciones';
import Beneficios from './components/Beneficios';
import Ahorros from './components/Ahorros';
import Transparencia from './components/Transparencia';
import Creditos from './components/Creditos';
import Cobranzas from './components/Cobranzas';
import TesoreriaBoveda from './components/TesoreriaBoveda';
import CierreDiario from './components/CierreDiario';
import ProtectedRoute from './components/ProtectedRoute';
import Solicitar_Prestamo from './components/Solicitar_Prestamo'; // Kept if needed, though SolicitudCredito is used
import Register from './components/Register';
import SocioSearch from './components/SocioSearch';
import SocioMain from './components/SocioMain';
import SocioDetalle from './components/SocioDetalle';
import SocioEditar from './components/SocioEditar';
import BandejaAprobaciones from './components/BandejaAprobacionSocio';
import SolicitudCredito from './components/SolicitudCredito';
import BandejaMasivaAprobaciones from './components/BandejaMasivaAprobaciones';
import VerificarContrato from './components/VerificarContrato';
import ConfirmarFirma from './components/ConfirmarFirma';
import Caja from './components/Caja';
import HistorialCreditos from './components/HistorialCreditos';
import ProcesosList from './components/ProcesosList';
import LogDetalleProcesos from './components/LogDetalleProcesos';
import NacionalidadForm from './components/NacionalidadForm';
import NacionalidadesList from './components/NacionalidadesList'
import EstadosCivilesList from './components/EstadosCivilesList';
import EstadoCivilForm from './components/EstadoCivilForm';
import EstadoSocioForm from './components/EstadoSocioForm';
import EstadosSocioList from './components/EstadosSocioList';
import MonedaForm from './components/MonedaForm';
import MonedasList from './components/MonedasList';
import FormasPagoList from './components/FormasPagoList';
import FormaPagoForm from './components/FormaPagoForm';
import CajasList from './components/CajasList';
import CajaForm from './components/CajaForm';
import PlantillaDocumentoForm from './components/PlantillaDocumentoForm';
import PlantillasDocumentoList from './components/PlantillasDocumentoList';
import TipoDocumentoForm from './components/TipoDocumentoForm';
import TiposDocumentoList from './components/TiposDocumentoList';
import MovimientosList from './components/MovimientosList';
import CategoriaDocumentoForm from './components/CategoriaDocumentoForm';
import CategoriasDocumentoList from './components/CategoriasDocumentoList';
import TipoCuentaForm from './components/TipoCuentaForm';
import TiposCuentaList from './components/TiposCuentaList';
import PlanCuentaForm from './components/PlanCuentaForm';
import PlanCuentasList from './components/PlanCuentasList';
import TiposCreditoList from './components/TiposCreditoList';
import TipoCreditoForm from './components/TipoCreditoForm';
import LineaCreditoForm from './components/LineaCreditoForm';
import LineasCreditoList from './components/LineasCreditoList';
import ProfesionesList from './components/ProfesionesList';
import ProfesionForm from './components/ProfesionForm';
import ParentescosList from './components/ParentescosList';
import ParentescoForm from './components/ParentescoForm';
import GenerosList from './components/GenerosList';
import GeneroForm from './components/GeneroForm';
import TiposIngresoList from './components/TiposIngresoList';
import TipoIngresoForm from './components/TipoIngresoForm';
import RangoAntiguedadList from './components/RangoAntiguedadList';
import RangoAntiguedadForm from './components/RangoAntiguedadForm';
import DestinoCreditoList from './components/DestinoCreditoList';
import DestinoCreditoForm from './components/DestinoCreditoForm';
import EstadoCreditoList from './components/EstadoCreditoList';
import EstadoCreditoForm from './components/EstadoCreditoForm';
import EstadoCuentaList from './components/EstadoCuentaList';
import EstadoCuentaForm from './components/EstadoCuentaForm';
import CalificacionRiesgoList from './components/CalificacionRiesgoList';
import CalificacionRiesgoForm from './components/CalificacionRiesgoForm';
import NivelFidelidadList from './components/NivelFidelidadList';
import NivelFidelidadForm from './components/NivelFidelidadForm';
import ReglaCreditoList from './components/ReglaCreditoList';
import ReglaCreditoForm from './components/ReglaCreditoForm';
import TasaList from './components/TasaList';
import TasaForm from './components/TasaForm';
import RolesList from './components/RolesList';
import RolForm from './components/RolForm';
import UsuariosList from './components/UsuariosList';
import UsuarioForm from './components/UsuarioForm';
import PermisosList from './components/PermisosList';
import PermisoForm from './components/PermisoForm';
import SucursalesList from './components/SucursalesList';
import SucursalForm from './components/SucursalForm';
import DepartamentosList from './components/DepartamentosList';
import DepartamentoForm from './components/DepartamentoForm';
import CiudadesList from './components/CiudadesList';
import CiudadForm from './components/CiudadForm';
import BarriosList from './components/BarriosList';
import BarrioForm from './components/BarrioForm';
import ConfiguracionEntidadForm from './components/ConfiguracionEntidadForm';
import SocioDashboard from './components/SocioDashboard';
import PrestamoDashboard from './components/PrestamoDashboard';
import ContabilidadMain from './components/contabilidad/ContabilidadMain';
import LibroDiario from './components/contabilidad/LibroDiario';
import LibroMayor from './components/contabilidad/LibroMayor';
import BalanceSaldos from './components/contabilidad/BalanceSaldos';
import BalanceGeneral from './components/contabilidad/BalanceGeneral';
import EstadoResultados from './components/contabilidad/EstadoResultados';
import ParametrosGlobalesList from './components/ParametrosGlobalesList';
import ParametroGlobalForm from './components/ParametroGlobalForm';
import TiposSocioList from './components/TiposSocioList';
import TipoSocioForm from './components/TipoSocioForm';
import CategoriasList from './components/CategoriasList';
import CategoriaForm from './components/CategoriaForm';
import EstadoValidoCreditoForm from './components/EstadoValidoCreditoForm';
import EstadosValidoCreditoList from './components/EstadosValidoCreditoList';


import SeguridadHub from './components/SeguridadHub';
import LoginAuditoriaList from './components/LoginAuditoriaList';


import loginImg from './img/login2.png';

// Componente para la lógica de las rutas
function AppRoutes() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return (
      <div
        className="min-h-screen"
        style={{
          backgroundImage: `url(${loginImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed'
        }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </div>
    );
  }

  return (
    <MainLayout>
      <Routes>
        <Route path="/" element={<Dashboard />} />

        {/* --- MODULO SOCIOS --- */}
        <Route element={
          <ProtectedRoute requiredPermission="socios.read">
            <ModuleLayout
              title="Membresía y Socios"
              menuItems={[
                { name: 'Gestor de Socios', href: '/socios', icon: Search },
                { name: 'Nuevo Socio', href: '/socios/nuevo', icon: PlusCircle, permission: 'socios.create' },
                { name: 'Aprobar', href: '/socios/aprobacion', icon: PenTool, permission: 'socios.update' },
                { name: 'Dar de Baja', href: '/socios/baja', icon: UserMinus, permission: 'socios.delete' }
              ]}
            />
          </ProtectedRoute>
        }>
          <Route path="/socios" element={<SocioMain />} />
          <Route path="/socios/nuevo" element={<Socios />} />
          <Route path="/socios/buscar" element={<SocioMain />} />
          <Route path="/socios/detalle/:id" element={<SocioDetalle />} />
          <Route path="/socios/editar/:id" element={<SocioEditar />} />
          <Route path="/socios/aprobacion" element={<BandejaAprobaciones />} />
          <Route path="/socios/:id/verificar-solicitud" element={<VerificarContrato />} />
          <Route path="/socios/:id/confirmar-firma" element={<ConfirmarFirma />} />
          <Route path="/socios/baja" element={<div className="p-4">Funcionalidad de Baja en construcción</div>} />
        </Route>

        {/* --- MODULO PARAMETRIZACION --- */}
        <Route element={
          <ProtectedRoute requiredPermission="config.read">
            <ModuleLayout
              title="Parametrización"
              menuItems={[
                { name: 'Personas', href: '/parametrizacion/personas', icon: Users },
                { name: 'Productos Financieros', href: '/parametrizacion/productos', icon: CreditCard },
                { name: 'Tesorería', href: '/parametrizacion/tesoreria', icon: DollarSign },
                { name: 'Global', href: '/parametrizacion/global', icon: Settings }
              ]}
            />
          </ProtectedRoute>
        }>
          <Route path="/parametrizacion" element={<Navigate to="/parametrizacion/personas" replace />} />
          <Route element={<ModuleLayout title="Parametrización > Personas" />}>
            <Route path="/parametrizacion/personas" element={<PersonasParametrizacion />} />
          </Route>
          <Route element={<ModuleLayout title="Parametrización > Productos" />}>
            <Route path="/parametrizacion/productos" element={<ProductosParametrizacion />} />
          </Route>
          <Route element={<ModuleLayout title="Parametrización > Tesorería" />}>
            <Route path="/parametrizacion/tesoreria" element={<TesoreriaParametrizacion />} />
          </Route>
          <Route element={<ModuleLayout title="Parametrización > Global" />}>
            <Route path="/parametrizacion/global" element={<GlobalParametrizacion />} />
          </Route>
          {/* ... rutas de parametrización existentes ... */}

          {/* Profesiones CRUD */}
          <Route path="/parametrizacion/profesiones" element={<ProfesionesList />} />
          <Route path="/parametrizacion/profesiones/nuevo" element={<ProfesionForm />} />
          <Route path="/parametrizacion/profesiones/:id/editar" element={<ProfesionForm />} />
          {/* Parentescos CRUD */}
          <Route path="/parametrizacion/parentescos" element={<ParentescosList />} />
          <Route path="/parametrizacion/parentescos/nuevo" element={<ParentescoForm />} />
          <Route path="/parametrizacion/parentescos/:id/editar" element={<ParentescoForm />} />
          {/* Generos CRUD */}
          <Route element={<ModuleLayout title="Parametrización > Géneros" />}>
            <Route path="/parametrizacion/generos" element={<GenerosList />} />
          </Route>
          <Route path="/parametrizacion/generos/nuevo" element={<GeneroForm />} />
          <Route path="/parametrizacion/generos/:id/editar" element={<GeneroForm />} />

          <Route element={<ModuleLayout title="Parametrización > Nacionalidades" />}>
            <Route path="/parametrizacion/nacionalidades" element={<NacionalidadesList />} />
          </Route>
          <Route path="/parametrizacion/nacionalidades/nuevo" element={<NacionalidadForm />} />
          <Route path="/parametrizacion/nacionalidades/:id/editar" element={<NacionalidadForm />} />

          <Route element={<ModuleLayout title="Parametrización > Estados Civiles" />}>
            <Route path="/parametrizacion/estados-civiles" element={<EstadosCivilesList />} />
          </Route>
          <Route path="/parametrizacion/estados-civiles/nuevo" element={<EstadoCivilForm />} />
          <Route path="/parametrizacion/estados-civiles/:id/editar" element={<EstadoCivilForm />} />
          <Route path="/parametrizacion/estados-socio" element={<EstadosSocioList />} />
          <Route path="/parametrizacion/estados-socio/nuevo" element={<EstadoSocioForm />} />
          <Route path="/parametrizacion/estados-socio/:id/editar" element={<EstadoSocioForm />} />
          <Route path="/parametrizacion/monedas" element={<MonedasList />} />
          <Route path="/parametrizacion/monedas/nuevo" element={<MonedaForm />} />
          <Route path="/parametrizacion/monedas/:id/editar" element={<MonedaForm />} />
          <Route path="/parametrizacion/formas-pago" element={<FormasPagoList />} />
          <Route path="/parametrizacion/formas-pago/nuevo" element={<FormaPagoForm />} />
          <Route path="/parametrizacion/formas-pago/:id/editar" element={<FormaPagoForm />} />
          <Route path="/parametrizacion/cajas" element={<CajasList />} />
          <Route path="/parametrizacion/cajas/nuevo" element={<CajaForm />} />
          <Route path="/parametrizacion/cajas/:id/editar" element={<CajaForm />} />
          
          <Route path="/parametrizacion/sucursales" element={<SucursalesList />} />
          <Route path="/parametrizacion/sucursales/nuevo" element={<SucursalForm />} />
          <Route path="/parametrizacion/sucursales/:id/editar" element={<SucursalForm />} />

          {/* Geografía y Entidad */}
          <Route path="/parametrizacion/departamentos" element={<DepartamentosList />} />
          <Route path="/parametrizacion/departamentos/nuevo" element={<DepartamentoForm />} />
          <Route path="/parametrizacion/departamentos/:id/editar" element={<DepartamentoForm />} />

          <Route path="/parametrizacion/ciudades" element={<CiudadesList />} />
          <Route path="/parametrizacion/ciudades/nuevo" element={<CiudadForm />} />
          <Route path="/parametrizacion/ciudades/:id/editar" element={<CiudadForm />} />

          <Route path="/parametrizacion/barrios" element={<BarriosList />} />
          <Route path="/parametrizacion/barrios/nuevo" element={<BarrioForm />} />
          <Route path="/parametrizacion/barrios/:id/editar" element={<BarrioForm />} />

          <Route path="/parametrizacion/configuracion-entidad" element={<ConfiguracionEntidadForm />} />
          <Route path="/parametrizacion/plantillas-documento" element={<PlantillasDocumentoList />} />
          <Route path="/parametrizacion/plantillas-documento/nuevo" element={<PlantillaDocumentoForm />} />
          <Route path="/parametrizacion/plantillas-documento/:id/editar" element={<PlantillaDocumentoForm />} />

          <Route path="/parametrizacion/tipos-documento" element={<TiposDocumentoList />} />
          <Route path="/parametrizacion/tipos-documento/nuevo" element={<TipoDocumentoForm />} />
          <Route path="/parametrizacion/tipos-documento/:id/editar" element={<TipoDocumentoForm />} />

          <Route path="/parametrizacion/categorias-documento" element={<CategoriasDocumentoList />} />
          <Route path="/parametrizacion/categorias-documento/nuevo" element={<CategoriaDocumentoForm />} />
          <Route path="/parametrizacion/categorias-documento/:id/editar" element={<CategoriaDocumentoForm />} />

          <Route path="/parametrizacion/tipos-cuenta" element={<TiposCuentaList />} />
          <Route path="/parametrizacion/tipos-cuenta/nuevo" element={<TipoCuentaForm />} />
          <Route path="/parametrizacion/tipos-cuenta/:id/editar" element={<TipoCuentaForm />} />

          <Route path="/parametrizacion/plan-cuentas" element={<PlanCuentasList />} />
          <Route path="/parametrizacion/plan-cuentas/nuevo" element={<PlanCuentaForm />} />
          <Route path="/parametrizacion/plan-cuentas/:id/editar" element={<PlanCuentaForm />} />

          <Route path="/parametrizacion/tipos-credito" element={<TiposCreditoList />} />
          <Route path="/parametrizacion/tipos-credito/nuevo" element={<TipoCreditoForm />} />
          <Route path="/parametrizacion/tipos-credito/:id/editar" element={<TipoCreditoForm />} />

          <Route path="/parametrizacion/lineas-credito" element={<LineasCreditoList />} />
          <Route path="/parametrizacion/lineas-credito/nuevo" element={<LineaCreditoForm />} />
          <Route path="/parametrizacion/lineas-credito/:id/editar" element={<LineaCreditoForm />} />
          <Route path="/parametrizacion/tipos-ingreso" element={<TiposIngresoList />} />
          <Route path="/parametrizacion/tipos-ingreso/nuevo" element={<TipoIngresoForm />} />
          <Route path="/parametrizacion/tipos-ingreso/:id/editar" element={<TipoIngresoForm />} />

          <Route path="/parametrizacion/destinos-fondos" element={<DestinoCreditoList />} />
          <Route path="/parametrizacion/destinos-fondos/nuevo" element={<DestinoCreditoForm />} />
          <Route path="/parametrizacion/destinos-fondos/:id/editar" element={<DestinoCreditoForm />} />

          <Route path="/parametrizacion/estados-credito" element={<EstadoCreditoList />} />
          <Route path="/parametrizacion/estados-credito/nuevo" element={<EstadoCreditoForm />} />
          <Route path="/parametrizacion/estados-credito/:id/editar" element={<EstadoCreditoForm />} />

          <Route path="/parametrizacion/estados-cuenta" element={<EstadoCuentaList />} />
          <Route path="/parametrizacion/estados-cuenta/nuevo" element={<EstadoCuentaForm />} />
          <Route path="/parametrizacion/estados-cuenta/:id/editar" element={<EstadoCuentaForm />} />

          <Route path="/parametrizacion/calificacion-riesgo" element={<CalificacionRiesgoList />} />
          <Route path="/parametrizacion/calificacion-riesgo/nuevo" element={<CalificacionRiesgoForm />} />
          <Route path="/parametrizacion/calificacion-riesgo/:id/editar" element={<CalificacionRiesgoForm />} />

          <Route path="/parametrizacion/niveles-fidelidad" element={<NivelFidelidadList />} />
          <Route path="/parametrizacion/niveles-fidelidad/nuevo" element={<NivelFidelidadForm />} />
          <Route path="/parametrizacion/niveles-fidelidad/:id/editar" element={<NivelFidelidadForm />} />

          <Route path="/parametrizacion/reglas-credito" element={<ReglaCreditoList />} />
          <Route path="/parametrizacion/reglas-credito/nuevo" element={<ReglaCreditoForm />} />
          <Route path="/parametrizacion/reglas-credito/:id/editar" element={<ReglaCreditoForm />} />

          <Route path="/parametrizacion/tasas" element={<TasaList />} />
          <Route path="/parametrizacion/tasas/nueva" element={<TasaForm />} />
          <Route path="/parametrizacion/tasas/:id/editar" element={<TasaForm />} />

          <Route path="/parametrizacion/rangos-antiguedad" element={<RangoAntiguedadList />} />
          <Route path="/parametrizacion/rangos-antiguedad/nuevo" element={<RangoAntiguedadForm />} />
          <Route path="/parametrizacion/rangos-antiguedad/:id/editar" element={<RangoAntiguedadForm />} />

          <Route path="/parametrizacion/estados-valido-credito" element={<EstadosValidoCreditoList />} />
          <Route path="/parametrizacion/estados-valido-credito/nuevo" element={<EstadoValidoCreditoForm />} />
          <Route path="/parametrizacion/estados-valido-credito/:id/editar" element={<EstadoValidoCreditoForm />} />

          <Route path="/parametrizacion/parametros-globales" element={<ParametrosGlobalesList />} />
          <Route path="/parametrizacion/parametros-globales/nuevo" element={<ParametroGlobalForm />} />
          <Route path="/parametrizacion/parametros-globales/:clave/editar" element={<ParametroGlobalForm />} />

          <Route path="/parametrizacion/tipos-socio" element={<TiposSocioList />} />
          <Route path="/parametrizacion/tipos-socio/nuevo" element={<TipoSocioForm />} />
          <Route path="/parametrizacion/tipos-socio/:id/editar" element={<TipoSocioForm />} />

          <Route path="/parametrizacion/categorias" element={<CategoriasList />} />
          <Route path="/parametrizacion/categorias/nuevo" element={<CategoriaForm />} />
          <Route path="/parametrizacion/categorias/:id/editar" element={<CategoriaForm />} />

          <Route path="/parametrizacion/*" element={<div className="p-8 text-center"><h2 className="text-xl font-bold bg-yellow-100 p-4 rounded text-yellow-800">Gestión de Tabla en Construcción</h2><p className="mt-2 text-gray-500">Pronto podrá administrar los registros aquí.</p></div>} />
        </Route>

        {/* --- MODULO SEGURIDAD --- */}
        <Route element={
          <ProtectedRoute requiredPermission="seguridad.read">
            <ModuleLayout
              title="Seguridad y Accesos"
              menuItems={[
                { name: 'Usuarios', href: '/seguridad/usuarios', icon: Users },
                { name: 'Roles', href: '/seguridad/roles', icon: Lock },
                { name: 'Permisos', href: '/seguridad/permisos', icon: ShieldCheck },
                { name: 'Auditoría de Accesos', href: '/seguridad/auditoria-accesos', icon: ShieldCheck }
              ]}
            />
          </ProtectedRoute>
        }>
          <Route path="/seguridad" element={<SeguridadHub />} />
          <Route path="/seguridad/usuarios" element={<UsuariosList />} />
          <Route path="/seguridad/usuarios/nuevo" element={<UsuarioForm />} />
          <Route path="/seguridad/usuarios/:id/editar" element={<UsuarioForm />} />
          <Route path="/seguridad/roles" element={<RolesList />} />
          <Route path="/seguridad/roles/nuevo" element={<RolForm />} />
          <Route path="/seguridad/roles/:id/editar" element={<RolForm />} />
          <Route path="/seguridad/permisos" element={<PermisosList />} />
          <Route path="/seguridad/permisos/nuevo" element={<PermisoForm />} />
          <Route path="/seguridad/permisos/:id/editar" element={<PermisoForm />} />
          <Route path="/seguridad/auditoria-accesos" element={<LoginAuditoriaList />} />
        </Route>

        {/* --- MODULO CAJA --- */}
        <Route element={
          <ProtectedRoute requiredPermission="caja.read">
            <ModuleLayout
              title="Caja y Movimientos"
              menuItems={[
                { name: 'Operaciones', href: '/caja', icon: DollarSign },
                { name: 'Arqueo', href: '/caja/arqueo', icon: Calculator },
                { name: 'Cierre de Caja', href: '/caja/cierre', icon: Lock },
                { name: 'Reporte Diario', href: '/caja/reporte', icon: FileText }
              ]}
            />
          </ProtectedRoute>
        }>
          <Route path="/caja" element={<Caja />} />
          <Route path="/caja/arqueo" element={<ArqueoCaja />} />
          <Route path="/caja/cierre" element={<ArqueoCaja />} />
          <Route path="/caja/reporte" element={<div className="p-8 text-center text-gray-500">Reporte Diario en construcción</div>} />
        </Route>

        {/* --- MODULO TESORERIA (BOVEDA Y EOD) --- */}
        <Route element={
          <ProtectedRoute requiredPermission="tesoreria.read">
            <ModuleLayout
              title="Tesorería y Control"
              menuItems={[
                { name: 'Gestión de Tesorería', href: '/tesoreria/boveda', icon: Building2, permission: 'tesoreria.admin' },
                { name: 'Cierre de Día (EOD)', href: '/tesoreria/cierre-diario', icon: ShieldCheck, permission: 'tesoreria.cierre' }
              ]}
            />
          </ProtectedRoute>
        }>
          <Route path="/tesoreria/boveda" element={<TesoreriaBoveda />} />
          <Route path="/tesoreria/cierre-diario" element={<CierreDiario />} />
        </Route>

        {/* --- MODULO PRÉSTAMOS --- */}
        <Route element={
          <ProtectedRoute requiredPermission="creditos.read">
            <ModuleLayout
              title="Gestión de Préstamos"
              menuItems={[
                { name: 'Solicitud', href: '/creditos', icon: PlusCircle, permission: 'creditos.create' },
                { name: 'Solicitudes', href: '/creditos/solicitudes', icon: FileText, permission: 'creditos.approve' },
                { name: 'Historial', href: '/creditos/historial', icon: Layers, permission: 'creditos.read' },
                { name: 'Desembolsos', href: '/creditos/desembolsos', icon: Banknote, permission: 'creditos.read' },
                { name: 'Cartera', href: '/creditos/listado', icon: Users, permission: 'creditos.read' }
              ]}
            />
          </ProtectedRoute>
        }>
          <Route path="/creditos" element={<ProtectedRoute requiredPermission="creditos.create"><SolicitudCredito /></ProtectedRoute>} />
          <Route path="/creditos/listado" element={<Creditos />} />
          <Route path="/creditos/solicitudes" element={<ProtectedRoute requiredPermission="creditos.approve"><BandejaMasivaAprobaciones /></ProtectedRoute>} />
          <Route path="/creditos/historial" element={<HistorialCreditos />} />
          <Route path="/creditos/desembolsos" element={<div className="p-8 text-center text-gray-500">Módulo de Desembolsos en construcción</div>} />
        </Route>

        {/* --- MODULO COBRANZAS --- */}
        <Route path="/cobranzas" element={
          <ProtectedRoute requiredPermission="creditos.read">
            <ModuleLayout title="Recuperaciones" menuItems={[{ name: 'Gestión de Mora', href: '/cobranzas', icon: Phone }]}>
              <Cobranzas />
            </ModuleLayout>
          </ProtectedRoute>
        } />

        {/* --- OTROS MODULOS --- */}

        <Route path="/finanzas" element={
          <ProtectedRoute requiredPermission="finanzas.read">
            <ModuleLayout title="Finanzas" menuItems={[{ name: 'General', href: '/finanzas', icon: Wallet }]}>
              <Finanzas />
            </ModuleLayout>
          </ProtectedRoute>
        } />

        <Route path="/ahorros" element={
          <ProtectedRoute requiredPermission="ahorros.read">
            <ModuleLayout title="Ahorros" menuItems={[{ name: 'Mis Ahorros', href: '/ahorros', icon: PiggyBank }]}>
              <Ahorros />
            </ModuleLayout>
          </ProtectedRoute>
        } />

        <Route path="/votaciones" element={
          <ProtectedRoute requiredPermission="votaciones.read">
            <ModuleLayout title="Votaciones" menuItems={[{ name: 'Activas', href: '/votaciones', icon: Vote }]}>
              <Votaciones />
            </ModuleLayout>
          </ProtectedRoute>
        } />

        <Route path="/beneficios" element={
          <ProtectedRoute requiredPermission="beneficios.read">
            <ModuleLayout title="Beneficios" menuItems={[{ name: 'Disponibles', href: '/beneficios', icon: Gift }]}>
              <Beneficios />
            </ModuleLayout>
          </ProtectedRoute>
        } />

        <Route path="/movimientos" element={
          <ProtectedRoute requiredPermission="movimientos.read">
            <ModuleLayout title="Auditoría de Movimientos" menuItems={[{ name: 'Historial', href: '/movimientos', icon: FileText }]}>
              <MovimientosList />
            </ModuleLayout>
          </ProtectedRoute>
        } />

        <Route path="/transparencia" element={
          <ProtectedRoute requiredPermission="transparencia.read">
            <ModuleLayout title="Transparencia" menuItems={[{ name: 'Documentos', href: '/transparencia', icon: FileText }]}>
              <Transparencia />
            </ModuleLayout>
          </ProtectedRoute>
        } />


        {/* MODULO PROCESOS AUTOMATICOS */}
        <Route path="/procesos" element={
          <ProtectedRoute requiredPermission="config.read">
            <ModuleLayout 
              title="Automatización" 
              menuItems={[
                { name: 'Monitor de Procesos', href: '/procesos', icon: Layers },
                { name: 'Log de Procesos', href: '/procesos/logs', icon: FileText }
              ]}
            >
              <ProcesosList />
            </ModuleLayout>
          </ProtectedRoute>
        } />

        <Route path="/procesos/logs" element={
          <ProtectedRoute requiredPermission="config.read">
            <ModuleLayout 
              title="Automatización > Log de Procesos" 
              menuItems={[
                { name: 'Monitor de Procesos', href: '/procesos', icon: Layers },
                { name: 'Log de Procesos', href: '/procesos/logs', icon: FileText }
              ]}
            >
              <div className="p-6 h-[calc(100vh-120px)]">
                <LogDetalleProcesos />
              </div>
            </ModuleLayout>
          </ProtectedRoute>
        } />

        {/* --- MODULO INFORMES (GERENCIA) --- */}
        <Route element={
          <ProtectedRoute requiredPermission="informes.read">
            <ModuleLayout
              title="Informes y Estadísticas"
              menuItems={[
                { name: 'Reporte de Socios', href: '/informes/socios', icon: Users },
                { name: 'Reporte de Préstamos', href: '/informes/prestamos', icon: Banknote }
              ]}
            />
          </ProtectedRoute>
        }>
          <Route path="/informes/socios" element={<SocioDashboard />} />
          <Route path="/informes/prestamos" element={<PrestamoDashboard />} />
        </Route>

        {/* --- MODULO CONTABILIDAD --- */}
        <Route element={
          <ProtectedRoute requiredPermission="finanzas.read">
            <ModuleLayout
              title="Gestión Contable"
              menuItems={[
                { name: 'Libro Diario', href: '/contabilidad/diario', icon: FileText },
                { name: 'Libro Mayor', href: '/contabilidad/mayor', icon: Layers },
                { name: 'Sumas y Saldos', href: '/contabilidad/balance-saldos', icon: Calculator },
                { name: 'Balance General', href: '/contabilidad/balance-general', icon: Landmark },
                { name: 'Estado Resultados', href: '/contabilidad/estado-resultados', icon: ChartBar },
                { name: 'Plan de Cuentas', href: '/contabilidad/plan-cuentas', icon: Search }
              ]}
            />
          </ProtectedRoute>
        }>
          <Route path="/contabilidad" element={<Navigate to="/contabilidad/diario" replace />} />
          <Route path="/contabilidad/diario" element={<LibroDiario />} />
          <Route path="/contabilidad/mayor" element={<LibroMayor />} />
          <Route path="/contabilidad/balance-saldos" element={<BalanceSaldos />} />
          <Route path="/contabilidad/balance-general" element={<BalanceGeneral />} />
          <Route path="/contabilidad/estado-resultados" element={<EstadoResultados />} />
          <Route path="/contabilidad/plan-cuentas" element={<PlanCuentasList />} />
        </Route>

        {/* Fallback for authenticated users */}
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>
    </MainLayout>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
